export default {
  version: process.env.REACT_APP_VERSION.substring(
    0,
    process.env.REACT_APP_VERSION.lastIndexOf('.')
  ),
};
